import NotInEvaluator from './NotInEvaluator';

export default class NotInUseEvaluator extends NotInEvaluator {
  constructor(fieldName, friendlyFieldName, model, mutator = null, vue = null) {
    super(fieldName, friendlyFieldName, model, mutator, vue);
    this.evaluatorName = 'not_in_use';
  }
}
